const BaseComponent = require('base/base-component');
const Util = require('helper/util');

class QinghaiNav extends BaseComponent {
  init () {
    this.float = this.$el.find('.inner-container').data('float');
    if (!Util.isIE(8)) {
      this.$el.find('.js-head-menu').lavalamp({
        easing: 'easeOutBack'
      });
    }
    /* 头部浮动 */
    if (this.float && this.float !== 'missing helper') {
      $(window).on('scroll', () => this.headFolat());
    }
  }
  headFolat () {
    const _scrollTop = $(document).scrollTop();
    if (_scrollTop > 170) {
      this.$el.addClass('floating');
    } else {
      this.$el.removeClass('floating');
    }
  }
}
module.exports = QinghaiNav;
